import { useTheme } from 'next-themes';

export default function ThemeToggle() {
  const { theme, setTheme, systemTheme } = useTheme();
  const current = theme === 'system' ? systemTheme : theme;

  return (
    <button
      onClick={() => setTheme(current === 'dark' ? 'light' : 'dark')}
      className="rounded-xl px-3 py-2 border border-slate-300 dark:border-slate-700"
      aria-label="Alternar tema"
      title="Alternar tema"
    >
      {current === 'dark' ? '☀️ Light' : '🌙 Dark'}
    </button>
  );
}
